export const state = {
  userInfo: {},
  navList: null,
  clickToken: null,
  tenantParams: {} // 租户信息
};
